import React from 'react';
import { Empty, Button } from 'antd';
import dayjs from 'dayjs';

import { ZeroState } from 'components/Icons';
import { AddIcon } from 'components/Icons';
import ProposalItemRenderer from './ProposalItemRenderer';

const ProposalList = ({
  proposals,
  trash,
  loading,
  onClickNewProposal,
  filterApplied,
  isLocked,
  itemRendererProps,
}) => {
  let prevMonth = '';

  const proposalMessage =
    trash === true
      ? 'There are no proposals in the trash'
      : 'There are no proposals in this selected filter';

  if (loading && proposals?.length === 0) {
    return null;
  }

  if (!proposals?.length) {
    return (
      <>
        {filterApplied ? (
          <Empty className="empty-view" description={proposalMessage} />
        ) : (
          <div className="no-proposals">
            <ZeroState className="feature-svg" />

            <p className="text">
              Create beautiful proposals with ease. Impress your clients and win more projects.
            </p>
            <a
              className="link"
              href="https://www.youtube.com/watch?v=0X7RfkLz7Zw"
              target="_blank"
              rel="noreferrer">
              🎓 Watch a short tutorial
            </a>

            <Button
              icon={<AddIcon />}
              disabled={isLocked}
              className={`large-btn secondary-btn icon-right ${isLocked ? 'disabled' : ''}`}
              onClick={onClickNewProposal}>
              NEW PROPOSAL
            </Button>
          </div>
        )}
      </>
    );
  }

  return proposals.map((proposal, proposalIndex) => {
    const currentMonth = dayjs(proposal.date).format('MMMM YYYY');
    const showMonthName = currentMonth !== prevMonth ? currentMonth : null;
    prevMonth = currentMonth;

    return (
      <ProposalItemRenderer
        key={`${proposalIndex}-${proposal._id}`}
        {...{
          proposal,
          proposalIndex,
          trash,
          showMonthName,
          ...itemRendererProps,
        }}
      />
    );
  });
};

export default React.memo(ProposalList);
